export function parseReportsSearch(search: Record<string, unknown>) {
  return {
    companyId: typeof search.companyId === "string" ? search.companyId : undefined,
    product: typeof search.product === "string" ? search.product : undefined,
    start: typeof search.start === "string" ? search.start : undefined,
    end: typeof search.end === "string" ? search.end : undefined,
    tab: typeof search.tab === "string" ? search.tab : undefined,
    snapshot: typeof search.snapshot === "string" ? search.snapshot : undefined,
    kind: typeof search.kind === "string" ? search.kind : undefined,
  }
}

export function formatReportingValidationIssues(issues: { path: (string | number)[]; message: string }[]): string {
  return issues.map(({ path, message }) => (path.length ? `${path.join(".")}: ${message}` : message)).join("; ")
}
